import React from "react";

const distinta = (props) => (
    <div>{props.id}</div>
);

export default distinta
